<mijn-login-template [title]="getTitle()" [showExtraContentCard]="false">
    <div header>
        @if (notification) {
            <ap-notification [status]="notification.status" apScrollAnchor="notification" data-bb="notification">
                <div [innerHtml]="notification.message"></div>
            </ap-notification>
        }
    </div>
    <klant-digicode-herstel
        [changeUsername]="changeUsername"
        [isProspect]="isHuismapLogin"
        [username]="currentUsername"
        (toLogin)="toLogin($event)"
        (notification)="setNotification($event)"
    >
    </klant-digicode-herstel>
</mijn-login-template>
